/*
 * Public API Surface of angular-embed-video
 */

export * from './lib/angular-embed-video.service';
export * from './lib/angular-embed-video.module';
